import React from 'react'
import classNames from 'classnames'

import { Heading, Image, Paragraph } from '@scentregroup/ui'
import Grid from '../grid'
import { FeaturedLink } from '../../../types/featured-link'
import { Link as LinkType } from '../../../types/link'

import style from './index.scss'

const SQUARE_THRESHOLD = 4

export const FeaturedLinksGrid: React.FC<{
  Link: LinkType
  featuredLinks: Array<FeaturedLink>
  itemsPerRow: number
  title: string
  className?: string
  square?: boolean
}> = ({
  Link,
  featuredLinks,
  itemsPerRow,
  title,
  className,
  square = itemsPerRow >= SQUARE_THRESHOLD,
}) => {
  const ratio = square ? 'square' : 'standard'
  return (
    <div className={classNames(style.FeaturedLinksGrid, className)}>
      {title && (
        <Heading type="small" className={style.heading}>
          {title}
        </Heading>
      )}
      <Grid itemsPerRow={itemsPerRow}>
        {featuredLinks.map(featuredLink => (
          <Link
            to={featuredLink.url}
            key={`${featuredLink.imageUrl}-${featuredLink.title}-${featuredLink.url}`}
            className={style.FeaturedLink}
          >
            <Image
              imageUrl={featuredLink.imageUrl}
              className={style.image}
              ratio={ratio}
              bgSize="cover"
              type="mobile"
            />
            <Paragraph className={style.paragraph}>
              {featuredLink.title}
            </Paragraph>
          </Link>
        ))}
      </Grid>
    </div>
  )
}
